import AddLoanRepayment from "../../components/expense/add/AddLoanRepayment";
import DialogBox from "../../components/UI/DialogBox";
import { handleErrMessage } from "../../functions/handleErrMessage";
import { Add_EXPENSE } from "../../api/allApi_List";
import usePostData from "../../CustomHooks/useAxios/usePostData";
import MainPageLayout from "../../layout/MainPageLayout";
import { prepareFormData } from "../../functions/prepareFormData";

const AddLoanRepaymentPage = () => {
  const { executePost, loading, formError, setFormError, successResponse } =
    usePostData();

  // execute post api
  const sendData = async (data, reset) => {
    // send data into form data
    const formData = prepareFormData(data);
    //API calling
    executePost(formData, Add_EXPENSE, reset);
  };

  return (
    <MainPageLayout headerConfig={{ title: "Add Loan Repayment" }}>
      <AddLoanRepayment
        sendData={sendData}
        loading={loading}
        successResponse={successResponse}
      />
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
    </MainPageLayout>
  );
};

export default AddLoanRepaymentPage;
